<!-- Hero Section with Integrated Promo -->
<div class="hero-section">
  <div class="container-fluid">
    <div class="hero-content-wrapper">
      <!-- Hero Image (70%) -->
      <div class="hero-image-container">
        <div class="carousel-wrapper">
          <div class="carousel-slides">
            <img src="assets/hero/DSC05919.JPG" class="hero-image" alt="Banner Image" />
            <img src="assets/hero/AV_00251.JPG" class="hero-image" alt="Banner Image" />
            <img src="assets/hero/AV_00241.JPG" class="hero-image" alt="Banner Image" />
            <img src="assets/hero/DSC05830.JPG" class="hero-image" alt="Banner Image" />
            <img [src]="siteUrl + 'api/static/' + bannerImage" class="hero-image" alt="Banner Image" />
            <!-- Duplicate first image for seamless loop -->
            <img src="assets/hero/DSC05919.JPG" class="hero-image" alt="Banner Image" />
          </div>
          <!-- <button class="carousel-button prev" (click)="prevSlide()">❮</button>
          <button class="carousel-button next" (click)="nextSlide()">❯</button> -->
          <!-- <div class="carousel-dots">
            <span *ngFor="let slide of slides; let i = index" 
                  class="dot" 
                  [class.active]="currentSlide === i"
                  (click)="goToSlide(i)">
            </span>
          </div> -->
        </div>
      </div>

      <!-- Promo Content (30%) -->
      <div class="hero-promo-container">
        <div class="mindsetshift-promo-card">
          <div class="promo-shine-effect"></div>
          <div class="promo-particles"></div>
          <div class="promo-content position-relative">
            <!-- <div class="promo-badge">NEW RELEASE</div> -->
            <div class="promo-content-wrapper">
              <h3 class="promo-title text-center">
                Helping You Rewire Your
                <span class="text-gradient">Mindset</span> <br />
                and Reset Your Life <br />
                <span class="highlight-text">In Just 20 Minutes a Day</span>
              </h3>
              <div class="promo-image-small">
                <img [src]="siteUrl + 'api/static/' + bookCover" alt="Mindsetshift Book" />
                <div class="glow-effect"></div>
              </div>
              <p class="promo-description text-center">
                Make the shift that changes everything.<br />
                The book that sparks your transformation is here.<br />
                Don't wait for change — create it.
              </p>
            </div>
            <div class="promo-buttons-container">
              <a href="https://rzp.io/rzp/L7zMqPrH">
                <div class="promo-button">
                  <span>Begin Your Journey</span>
                  <i class="fas fa-arrow-right ms-2"></i>
                </div>
              </a>
              <a href="/mindsetshift">
                <div class="promo-cta">
                  <span>Explore the Bundle</span>
                  <i class="fas fa-arrow-right ms-2"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="section events-section py-5">
  <div class="container-fluid px-3 px-md-5">
    <div class="row">
      <div class="col-md-6 mb-3 mb-md-0">
        <div class="pbmit-heading-subheading">
          <div class="title-wrapper">
            <span class="pbmit-subtitle-line" style="color: white"></span>
            <h4 class="pbmit-subtitle text-primary">Upcoming Events</h4>
            <div class="accent-line"></div>
          </div>
          <h1 class="pbmit-title gradient-title text-white">
            Latest <span class="text-secondary">Events</span>
          </h1>
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <div class="blog-button2">
          <a href="/events" class="pbmit-btn pbmit-btn-blackish">
            <span>Discover Events</span>
            <i class="fas fa-arrow-right ms-2"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="row g-6">
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
        (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
        (beforeChange)="beforeChange($event)">
        <article ngxSlickItem *ngFor="let slide of slides" class="pbmit-blog-style-2 slide px-2">
          <a class="event-card" [href]="'/event/' + slide.id">
            <img [src]="siteUrl + 'api/static' + slide.image" class="event-image" alt="{{ slide.name }}" />
            <div class="event-overlay">
              <h3 class="event-title">{{ slide.name }}</h3>
            </div>
          </a>
        </article>
      </ngx-slick-carousel>
    </div>
  </div>
</section>
<!-- About Section - Redesigned -->
<section class="section-xl overflow-hidden about-section">
  <div class="about-particles"></div>
  <div class="container-fluid px-4 px-md-5">
    <!-- Image and Content Row -->
    <div class="row mb-4">
      <!-- Image Column -->
      <div class="col-md-6 mb-4 mb-md-0">
        <div class="about-image-container">
          <div class="image-frame balanced-size">
            <img [src]="homePageVideoImage.title" class="img-fluid main-image" alt="About Us" />
            <div class="image-overlay"></div>
            <!-- Floating Elements -->
            <div class="floating-badge experience-badge">
              <div class="badge-content">
                <span class="years">15+</span>
                <span class="text">Years of Excellence</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Content Column -->
      <div class="col-md-6">
        <div class="about-content-wrapper px-2">
          <div class="pbmit-heading-subheading mb-4">
            <div class="title-wrapper">
              <span class="pbmit-subtitle-line"></span>
              <h4 class="pbmit-subtitle text-primary">{{ homeObj.title }}</h4>
              <div class="accent-line"></div>
            </div>
            <h2 class="about-title">
              Transforming <span class="text-gradient">Potential</span> Into
              <span class="text-gradient">Excellence</span>
            </h2>
          </div>

          <div class="about-description" [innerHTML]="homeObj.description"></div>
        </div>
      </div>
    </div>

    <!-- Features Row - Full Width -->
    <div class="row">
      <div class="col-12">
        <div class="features-grid-fullwidth">
          <div class="feature-item">
            <div class="feature-header">
              <div class="feature-icon">
                <i class="fas fa-star"></i>
              </div>
            </div>
            <div class="feature-content">
              <h4 class="feature-title">Power Within You Summit</h4>
              <p class="feature-description">
                Unlock your potential through our transformative leadership
                summit
              </p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-header">
              <div class="feature-icon">
                <i class="fas fa-road"></i>
              </div>
            </div>
            <div class="feature-content">
              <h4 class="feature-title">The Safalta Ka Rasta Experience</h4>
              <p class="feature-description">
                Navigate your path to success with our proven methodology
              </p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-header">
              <div class="feature-icon">
                <i class="fas fa-users"></i>
              </div>
            </div>
            <div class="feature-content">
              <h4 class="feature-title">Women in Leadership Series</h4>
              <p class="feature-description">
                Empowering women to lead with confidence and vision
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- About End -->
<!-- Blog Start -->
<section class="blog-section">
  <div class="container-fluid px-3 px-md-5">
    <div class="row align-items-center mb-3">
      <div class="col-md-6 mb-3 mb-md-0">
        <div class="pbmit-heading-subheading">
          <div class="title-wrapper">
            <span class="pbmit-subtitle-line"></span>
            <h4 class="pbmit-subtitle">NEWS UPDATE</h4>
            <div class="accent-line"></div>
          </div>
          <h2 class="pbmit-title">
            Think. <span class="text-primary">Create.</span> Elevate.
          </h2>
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-end align-items-center">
        <div class="blog-button2">
          <a href="/blogs" class="pbmit-btn pbmit-btn-blackish">
            <span>Explore All</span>
            <i class="fas fa-arrow-right ms-2"></i>
          </a>
        </div>
      </div>
    </div>

    <!-- New Blog Layout -->
    <div class="blogs-grid">
      <!-- Featured Blog (First Blog) -->
      <a class="featured-blog" *ngIf="blogs.length > 0" [href]="'/blog/' + blogs[0].id">
        <div class="blog-card-modern">
          <div class="blog-image-container">
            <img [src]="siteUrl + 'api/static' + blogs[0].image" alt="{{ blogs[0].title }}" />
          </div>
          <div class="blog-content-overlay">
            <div class="title-date-wrapper">
              <h3 class="blog-title">{{ blogs[0].title }}</h3>
              <div class="blog-date-badge">
                <span class="day">{{ blogs[0].blog_date | date : "dd" }}</span>
                <span class="month">{{
                  blogs[0].blog_date | date : "MMM"
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </a>

      <!-- Secondary Blogs -->
      <div class="secondary-blogs">
        <div class="blog-row" *ngFor="let blog of blogs.slice(1, 4)">
          <a class="blog-card-horizontal" [href]="'/blog/' + blog.id">
            <div class="blog-image-side">
              <img [src]="siteUrl + 'api/static' + blog.image" alt="{{ blog.title }}" />
            </div>
            <div class="blog-content-side">
              <div class="blog-date-small">
                {{ blog.blog_date | date : "dd MMM, yyyy" }}
              </div>
              <h4 class="blog-title-small">{{ blog.title }}</h4>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Footer Image Section -->
<div class="footer-image-section">
  <iframe width="100%" height="100%" src="https://www.youtube.com/embed/DX6DhmV9QyM?autoplay=1&mute=1&loop=1&playlist=DX6DhmV9QyM" frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen></iframe>
</div>